   <div id="map" style="height: 400px; width: 100%;  border: 1px solid #f2fafd;
  border-radius: 0.25rem;
  padding: 0.5rem; " ></div>
